module.exports = __webpack_public_path__ + "static/media/bt-invoices.ae088a51.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/bt-invoices.png
// module id = 686
// module chunks = 0